import React from 'react'
import {Async} from 'react-select';

const SelectInput = ({
                       className,
                       disabled,
                       isMulti,
                       name,
                       onChange,
                       options,
                       placeholder,
                       required,
                       value,
                       loadOptions,
                       noOptionsMessage
                     }) => {
  const renderExtraClass = () => {
    return `${disabled && 'react-select--disabled'} ${value && 'react-select--filled'}`
  };

  return (
    <React.Fragment>
      <div className="relative">
        <div className={`${renderExtraClass()} relative z1`}>
          <Async
            classNamePrefix={className}
            isDisabled={disabled}
            isMulti={isMulti}
            name={name}
            placeholder={placeholder}
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions
            noOptionsMessage={noOptionsMessage}
            onChange={onChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SelectInput;
